import http from './api'

const route = ''

export default {
    show: (username, contratoId, pagina) => {
        return http.post(route + 'listaprodutos', {
            username: username,
            contratoId: contratoId,
            page: pagina,
        })
    },

    listarLinhaProducao: (contratoId) => {
        return http.post(route + 'lista_linhaProducao', { contratoId: contratoId })
    },

    listarClassificacao: (contratoId) => {
        return http.post(route + 'lista_classificacao', { contratoId: contratoId })
    },

    listarProdutoLinha: (idLinhaProducao, username, contratoId) => {
        return http.post(route + 'listar_ProdutosLinha', {
            idLinhaProducao: idLinhaProducao,
            username: username,
            contratoId: contratoId,
        })
    },

    listarProdutoClassificacao: (idClassificacao, username, contratoId) => {
        return http.post(route + 'listar_ProdutosClassificacao', {
            idClassificacao: idClassificacao,
            username: username,
            contratoId: contratoId,
        })
    },

    listarProdutoLinhaClassificacao: (idLinhaProducao, idClassificacao, username, contratoId) => {
        return http.post(route + 'listar_ProdutosLinhaClassificacao', {
            idLinhaProducao: idLinhaProducao,
            idClassificacao: idClassificacao,
            username: username,
            contratoId: contratoId,
        })
    },

    showPromocao: (username, contratoId) => {
        return http.post(route + 'listaprodutospromocao', {
            username: username,
            contratoId: contratoId,
        })
    },

    showDescricao: (produtoId, username, contratoId, carrinhoId) => {
        return http.post(route + 'showDescricao', {
            produtoId: produtoId,
            username: username,
            contratoId: contratoId,
            carrinhoId: carrinhoId,
        })
    },
}
